import * as ko from 'knockout'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import Guard from '../../../../AppUtils/Framework/Guard'
import * as EventAggregator from '../../../../AppUtils/Framework/Messaging/EventAggregator'
import { BettingInformation } from '../../../Model/BettingInformation'
import ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'

export class FieldViewModel extends Disposable {
  public bettingContext: BettingInformation
  public raceKey: ObservableRaceKey
  public selected: ko.PureComputed<boolean>

  constructor(params: { raceKey: ObservableRaceKey; bettingContext: BettingInformation }) {
    super()
    Guard.notNull(params.bettingContext)
    Guard.notNull(params.raceKey)

    this.bettingContext = params.bettingContext
    this.raceKey = params.raceKey
    this.selected = ko.pureComputed<boolean>(() => {
      if (params.bettingContext.field()[this.raceKey.leg() - 1] !== undefined) {
        const field: boolean = params.bettingContext.field()[this.raceKey.leg() - 1]()
        return field
      }
      return false
    })

    this.registerDisposals(() => {
      this.selected.dispose()
    })
  }

  public toggle(option: unknown, event: Event): void {
    event.preventDefault()
    EventAggregator.publish('field-selected-command', {
      raceNumber: this.raceKey.raceNumber(),
      position: this.raceKey.leg() - 1,
      selected: !this.selected(),
    })
  }
}
